/**
 * Password form fields component with validation
 */

import { FormField } from '@/lib/base/forms/form-field';
import { Input } from '@/lib/base/forms/input/input';

import FormErrors from '../../../components/FormErrors';

interface PasswordFormFieldsProps {
  hasCurrentPassword: boolean;
  currentPassword: string;
  newPassword: string;
  newPassword2: string;
  onCurrentPasswordChange: (value: string) => void;
  onNewPasswordChange: (value: string) => void;
  onNewPassword2Change: (value: string) => void;
  serverErrors?: Array<{ param?: string; message: string }>;
}

export function PasswordFormFields({
  hasCurrentPassword,
  currentPassword,
  newPassword,
  newPassword2,
  onCurrentPasswordChange,
  onNewPasswordChange,
  onNewPassword2Change,
  serverErrors,
}: PasswordFormFieldsProps) {
  return (
    <div className='space-y-6'>
      {/* Current Password */}
      {hasCurrentPassword && (
        <div className='space-y-2'>
          <FormField
            name='current_password'
            label='Current password'
            isRequired
          >
            {({ isInvalid, showError, inputId }) => (
              <Input
                id={inputId}
                type='password'
                value={currentPassword}
                onChange={onCurrentPasswordChange}
                isInvalid={isInvalid}
                showError={showError}
                isRequired
                size='md'
                autoComplete='current-password'
                name='current_password'
                placeholder='Enter your current password'
              />
            )}
          </FormField>
          <FormErrors param='current_password' errors={serverErrors} />
        </div>
      )}

      {/* New Password */}
      <div className='space-y-2'>
        <FormField name='new_password' label='New password' isRequired>
          {({ isInvalid, showError, inputId }) => (
            <Input
              id={inputId}
              type='password'
              value={newPassword}
              onChange={onNewPasswordChange}
              isInvalid={isInvalid}
              showError={showError}
              isRequired
              size='md'
              autoComplete='new-password'
              name='new_password'
              placeholder='Enter your new password'
            />
          )}
        </FormField>
        <FormErrors param='new_password' errors={serverErrors} />
      </div>

      {/* Confirm New Password */}
      <div className='space-y-2'>
        <FormField name='new_password2' label='Confirm new password' isRequired>
          {({ isInvalid, showError, inputId }) => (
            <Input
              id={inputId}
              type='password'
              value={newPassword2}
              onChange={onNewPassword2Change}
              isInvalid={isInvalid}
              showError={showError}
              isRequired
              size='md'
              name='new_password2'
              placeholder='Confirm your new password'
            />
          )}
        </FormField>
        <FormErrors param='new_password2' errors={serverErrors} />
      </div>
    </div>
  );
}
